import { OrganizationType } from '@client/graphql/__generated__/types';
import { useAppContext } from '~/services/main/contexts/AppContext';

/**
 * True when the currently selected organization is a lender. Lenders get a
 * different entry point and navigation than brokerages because most brokerage
 * surfaces (transactions, compliance, pipeline, agent tools) do not apply.
 */
export const useIsLenderOrg = (): boolean => {
  const { selectedOrganization } = useAppContext();

  return selectedOrganization?.organizationType === OrganizationType.LENDER;
};
